import { TriangleExclamationRegularV6 } from "@shared/v2/Icomoon";

const WarningMessage = () => (
  <div className="tw-ml-[46px] tw-flex tw-gap-[12px] tw-rounded-8px tw-bg-[#E6EDFA] tw-p-[8px] tw-text-14px tw-leading-[20px] tw-font-normal tw-text-[#2454B2]">
    <div className="tw-flex tw-items-center">
      <TriangleExclamationRegularV6 />
    </div>
    <div>
      Note: Replying to this text will start a new message thread from your Brivity number. Be sure to
      introduce yourself 😄.
    </div>
  </div>
);

export default WarningMessage;
